import React from 'react';
import '../../styles/design-system.css';

/**
 * ProgressBar Component
 * Progress indicator matching iLovePDF design
 * 
 * @param {Object} props
 * @param {number} props.value - Progress value (0-100)
 * @param {string} props.variant - 'default' | 'success' | 'warning'
 * @param {boolean} props.striped - Show striped animation
 * @param {boolean} props.showLabel - Show percentage label
 */
const ProgressBar = ({
    value = 0,
    variant = 'default',
    striped = false,
    showLabel = true,
    className = ''
}) => {
    const clampedValue = Math.min(100, Math.max(0, value));

    const barClass = [
        'progress-bar',
        variant !== 'default' ? `progress-bar-${variant}` : '',
        striped ? 'progress-bar-striped' : ''
    ].filter(Boolean).join(' ');

    return (
        <div className={`progress-bar-wrapper ${className}`} style={{ marginBottom: 'var(--spacing-6)' }}>
            {showLabel && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: 'var(--spacing-2)',
                    fontSize: 'var(--text-sm)',
                    color: 'var(--color-text-secondary)'
                }}>
                    <span>Progress</span>
                    <span style={{ fontWeight: 'var(--font-semibold)' }}>
                        {Math.round(clampedValue)}%
                    </span>
                </div>
            )}
            <div className="progress">
                <div
                    className={barClass}
                    style={{ width: `${clampedValue}%` }}
                />
            </div>
        </div>
    );
};

export default ProgressBar;
